import { render, staticRenderFns } from "./SplitterTransference.vue?vue&type=template&id=4e9653c8&scoped=true"
import script from "./SplitterTransference.vue?vue&type=script&lang=js"
export * from "./SplitterTransference.vue?vue&type=script&lang=js"
import style0 from "./SplitterTransference.vue?vue&type=style&index=0&id=4e9653c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9653c8",
  null
  
)

export default component.exports